<p-toast></p-toast>
<div class="container-fluid container-fullw">
  <div class="p-fluid p-grid">
    <div class="p-col-12">
      <div>
        <p-fieldset [toggleable]="true">
          <ng-template pTemplate="header">
            <span *ngIf="banner.id === null">{{ 'NEWBANNER' | translate }}</span>
            <span *ngIf="banner.id !== null">{{ 'EDITBANNER' | translate }}</span>
          </ng-template>
          <form pFocusTrap name="bannerForm" id="bannerForm" novalidate (ngSubmit)="submitForm(true)" [formGroup]="bannerForm" >
            <input type="hidden" name="id" id="bannerId" formControlName="id" />
            <div class="p-fluid p-grid">
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <h2>{{ 'BANNERA' | translate }}</h2>
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-tag"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerName" formControlName="name" type="text" pInputText [required]="true"> 
                      <label for="bannerName" class="req">{{ 'NAME' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerForm.controls['name'].invalid && (bannerForm.controls['name'].dirty || bannerForm.controls['name'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['name'].errors !== null">
                  <div *ngIf="bannerForm.controls['name'].errors.required">
                   {{ 'NAMEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-cog"></i>
                    </span>
                    <span class="p-float-label">
                      <p-dropdown  inputId="bannerBannerTypeId" [autoDisplayFirst]="false" formControlName="bannerType" [options]="bannersColumnsService.bannerTypes" optionValue="id" optionLabel="name" [required]="true" [filter]="true"></p-dropdown>
                      <label for="bannerBannerTypeId" class="req">{{ 'BANNERTYPE' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerForm.controls['bannerType'].invalid && (bannerForm.controls['bannerType'].dirty || bannerForm.controls['bannerType'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['bannerType'].errors !== null">
                  <div *ngIf="bannerForm.controls['bannerType'].errors.required">
                   {{ 'BANNERTYPEREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-image"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerPicture" formControlName="picture" type="text" pInputText [required]="false"> 
                      <label for="bannerPicture" class="">{{ 'PICTURE' | translate }}</label>
                    </span>
                    <button type="button" pButton pRipple icon="pi pi-folder" styleClass="p-button-info" (click)="openFilerDialog('picture')"></button> 
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="bannerClosable" formControlName="closable" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="bannerClosable" class="p-d-inline-block p-ml-2 ">{{ 'CLOSABLE' | translate }}</label>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-arrow-down"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerCountDown" formControlName="countDown" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerCountDown" class="">{{ 'COUNTDOWN' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-world"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerWebAction" formControlName="webAction" type="text" pInputText [required]="true"> 
                      <label for="bannerWebAction" class="req">{{ 'WEBACTION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerForm.controls['webAction'].invalid && (bannerForm.controls['webAction'].dirty || bannerForm.controls['webAction'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['webAction'].errors !== null">
                  <div *ngIf="bannerForm.controls['webAction'].errors.required">
                   {{ 'WEBACTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-android"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerAndroidAction" formControlName="androidAction" type="text" pInputText [required]="true"> 
                      <label for="bannerAndroidAction" class="req">{{ 'ANDROIDACTION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerForm.controls['androidAction'].invalid && (bannerForm.controls['androidAction'].dirty || bannerForm.controls['androidAction'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['androidAction'].errors !== null">
                  <div *ngIf="bannerForm.controls['androidAction'].errors.required">
                   {{ 'ANDROIDACTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-apple"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerIphoneAction" formControlName="iphoneAction" type="text" pInputText [required]="true"> 
                      <label for="bannerIphoneAction" class="req">{{ 'IPHONEACTION' | translate }}</label>
                    </span>
                  </div>
                </div>
                <div *ngIf="bannerForm.controls['iphoneAction'].invalid && (bannerForm.controls['iphoneAction'].dirty || bannerForm.controls['iphoneAction'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['iphoneAction'].errors !== null">
                  <div *ngIf="bannerForm.controls['iphoneAction'].errors.required">
                   {{ 'IPHONEACTIONREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <h2>{{ 'BANNERB' | translate }}</h2>
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <label for="bannerGender" class="">{{ 'GENDER' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of bannersColumnsService.gendersOptions; let i = index">
                      <p-radioButton inputId="bannerGender_{{ i }}" formControlName="gender" name="gender" [value]="option.value"></p-radioButton>
                      <label for="bannerGender_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-exclamation"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerPriority" formControlName="priority" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerPriority" class="">{{ 'PRIORITY' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-birthday-cake"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMinAge" formControlName="minAge" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMinAge" class="">{{ 'MINAGE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-birthday-cake"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMaxAge" formControlName="maxAge" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMaxAge" class="">{{ 'MAXAGE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-link"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerWebUrl" formControlName="webUrl" type="text" pInputText [required]="false"> 
                      <label for="bannerWebUrl" class="">{{ 'WEBURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-phone"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerPhoneNumberToCall" formControlName="phoneNumberToCall" type="text" pInputText [required]="false"> 
                      <label for="bannerPhoneNumberToCall" class="">{{ 'PHONENUMBERTOCALL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-mobile"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerSmsMobileNumber" formControlName="smsMobileNumber" type="text" pInputText [required]="false"> 
                      <label for="bannerSmsMobileNumber" class="">{{ 'SMSMOBILENUMBER' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-calculator"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerSmsBody" formControlName="smsBody" type="text" pInputText [required]="false"> 
                      <label for="bannerSmsBody" class="">{{ 'SMSBODY' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-marker-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerEmailAdress" formControlName="emailAdress" type="text" pInputText [required]="false"> 
                      <label for="bannerEmailAdress" class="">{{ 'EMAILADRESS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-file-alt"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerEmailSubject" formControlName="emailSubject" type="text" pInputText [required]="false"> 
                      <label for="bannerEmailSubject" class="">{{ 'EMAILSUBJECT' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-calculator"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerEmailBody" formControlName="emailBody" type="text" pInputText [required]="false"> 
                      <label for="bannerEmailBody" class="">{{ 'EMAILBODY' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-android"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerAndroidAppUrl" formControlName="androidAppUrl" type="text" pInputText [required]="false"> 
                      <label for="bannerAndroidAppUrl" class="">{{ 'ANDROIDAPPURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-apple"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerIphoneAppUrl" formControlName="iphoneAppUrl" type="text" pInputText [required]="false"> 
                      <label for="bannerIphoneAppUrl" class="">{{ 'IPHONEAPPURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-youtube"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerYoutubeUrl" formControlName="youtubeUrl" type="text" pInputText [required]="false"> 
                      <label for="bannerYoutubeUrl" class="">{{ 'YOUTUBEURL' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-map-marker"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMapLatitude" formControlName="mapLatitude" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [step]="0.1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMapLatitude" class="">{{ 'MAPLATITUDE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-map-marker"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMapLongitude" formControlName="mapLongitude" mode="decimal" [minFractionDigits]="2" [maxFractionDigits]="2" [step]="0.1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMapLongitude" class="">{{ 'MAPLONGITUDE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-tv"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerScreen" formControlName="screen" type="text" pInputText [required]="false"> 
                      <label for="bannerScreen" class="">{{ 'SCREEN' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-cogs"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerScreenParameters" formControlName="screenParameters" type="text" pInputText [required]="false"> 
                      <label for="bannerScreenParameters" class="">{{ 'SCREENPARAMETERS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-layout"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerTemplate" formControlName="template" type="text" pInputText [required]="false"> 
                      <label for="bannerTemplate" class="">{{ 'TEMPLATE' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-text"></i>
                    </span>
                    <span class="p-float-label">
                      <input id="bannerAdText" formControlName="adText" type="text" pInputText [required]="false"> 
                      <label for="bannerAdText" class="">{{ 'ADTEXT' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setTextColor($event)" formControlName="textColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input type="text" pInputText id="bannerTextColor" formControlName="textColor" [required]="false">
                      <label for="bannerTextColor" class="p-d-inline-block p-ml-2 ">{{ 'TEXTCOLOR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-palette"></i>
                    </span>
                    <span class="p-inputgroup-addon" style="max-width: 1em;">
                      <p-colorPicker (onChange)="setBackgroundColor($event)" formControlName="backgroundColor"></p-colorPicker>
                    </span>
                    <span class="p-float-label">
                      <input type="text" pInputText id="bannerBackgroundColor" formControlName="backgroundColor" [required]="false">
                      <label for="bannerBackgroundColor" class="p-d-inline-block p-ml-2 ">{{ 'BACKGROUNDCOLOR' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <h2>{{ 'BANNERC' | translate }}</h2>
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-eye"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerTotalHits" formControlName="totalHits" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerTotalHits" class="">{{ 'TOTALHITS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-eye"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerTodayHits" formControlName="todayHits" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerTodayHits" class="">{{ 'TODAYHITS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-bar-chart"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerTotalClicks" formControlName="totalClicks" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerTotalClicks" class="">{{ 'TOTALCLICKS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-calendar-check"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerTodayClicks" formControlName="todayClicks" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerTodayClicks" class="">{{ 'TODAYCLICKS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <h2>{{ 'BANNERD' | translate }}</h2>
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12" [hidden]="common.currentUser.roles.join('').indexOf('ROLE_ADMIN_PUBLISHER') === -1" >
                  <label for="bannerStatus" class="req">{{ 'STATUS' | translate }}</label>
                  <div class="p-formgroup-inline">
                    <div class="p-field-checkbox" *ngFor="let option of bannersColumnsService.statusesOptions; let i = index">
                      <p-radioButton inputId="bannerStatus_{{ i }}" formControlName="status" name="status" [value]="option.value"></p-radioButton>
                      <label for="bannerStatus_{{ i }}">{{ option.label | translate }}</label>
                    </div>
                  </div>
                </div>
                <div *ngIf="bannerForm.controls['status'].invalid && (bannerForm.controls['status'].dirty || bannerForm.controls['status'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['status'].errors !== null">
                  <div *ngIf="bannerForm.controls['status'].errors.required">
                   {{ 'STATUSREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                    <p-toggleButton inputId="bannerAutoPublishing" formControlName="autoPublishing" onIcon="pi pi-check" offIcon="pi pi-times"  [style]="{'width': '2em'}"></p-toggleButton>
                    <label for="bannerAutoPublishing" class="p-d-inline-block p-ml-2 req">{{ 'AUTOPUBLISHING' | translate }}</label>
                </div>
                <div *ngIf="bannerForm.controls['autoPublishing'].invalid && (bannerForm.controls['autoPublishing'].dirty || bannerForm.controls['autoPublishing'].touched)" class="alert alert-danger">
                  <ng-container *ngIf="bannerForm.controls['autoPublishing'].errors !== null">
                  <div *ngIf="bannerForm.controls['autoPublishing'].errors.required">
                   {{ 'AUTOPUBLISHINGREQUIRED' | translate }}.
                  </div>
                  </ng-container>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-control-skip-forward"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="bannerStartPublishing" formControlName="startPublishing" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="false" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="bannerStartPublishing" class="">{{ 'STARTPUBLISHING' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-control-skip-backward"></i>
                    </span>
                    <span class="p-float-label">
                      <p-calendar inputId="bannerEndPublishing" formControlName="endPublishing" [showTime]="true" hourFormat="24" [showIcon]="true" [yearNavigator]="true" [monthNavigator]="true" [required]="false" yearRange="1900:2030" [stepHour]="1" [stepMinute]="15" [stepSecond]="0"></p-calendar>
                      <label for="bannerEndPublishing" class="">{{ 'ENDPUBLISHING' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerStartPublishingTime" formControlName="startPublishingTime" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerStartPublishingTime" class="">{{ 'STARTPUBLISHINGTIME' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-alarm-clock"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerEndPublishingTime" formControlName="endPublishingTime" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerEndPublishingTime" class="">{{ 'ENDPUBLISHINGTIME' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="far fa-calendar-check"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMaxClicksPerDay" formControlName="maxClicksPerDay" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMaxClicksPerDay" class="">{{ 'MAXCLICKSPERDAY' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="icon-bar-chart"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMaxTotalClicks" formControlName="maxTotalClicks" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMaxTotalClicks" class="">{{ 'MAXTOTALCLICKS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-eye"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMaxHitsPerDay" formControlName="maxHitsPerDay" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMaxHitsPerDay" class="">{{ 'MAXHITSPERDAY' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
              <div class="p-col-6">

                <div class="p-field p-col-12">
                  <div class="p-inputgroup">
                    <span class="p-inputgroup-addon">
                      <i class="fas fa-eye"></i>
                    </span>
                    <span class="p-float-label">
                      <p-inputNumber inputId="bannerMaxTotalHits" formControlName="maxTotalHits" [step]="1" [showButtons]="true" [required]="false"></p-inputNumber>
                      <label for="bannerMaxTotalHits" class="">{{ 'MAXTOTALHITS' | translate }}</label>
                    </span>
                  </div>
                </div>

              </div><!--/p-col-6-->
            </div><!--/p-fluid p-grid-->

            <div class="p-fluid p-grid">
              <div class="p-col-12">
                <label for="bannerBannerPositions" class="control-label">
                  <span>
                    {{ 'BANNERPOSITIONS' | translate }}
                  </span>
                  <span class="input-icon">
                    <input placeholder="{{ 'FILTERBANNERPOSITIONS' | translate }}" type="text" #bannerPositionsSearchText (input)="bannersColumnsService.filterBannerPositions(bannerPositionsSearchText.value)" class="form-control pull-right input-sm underline" />
                      <i class="icon-filter"></i>
                   </span><!--/input-icon-->
                </label>
              </div><!--/p-col-12-->
              <ng-container *ngFor="let bannerPosition of bannersColumnsService.bannerPositionsFiltered">
                <div class="p-col-3 p-field-checkbox" *ngIf="bannerPosition.id">
                  <p-checkbox name="bannerPositions" [formControl]="$any(bannerForm).controls['bannerPositions']" [value]="bannerPosition.id" label="{{ bannerPosition.name }}"></p-checkbox>
                </div><!--/p-col-3-->
              </ng-container>
              <div class="p-col-12">
                <div class="p-field-checkbox">
                  <p-checkbox (onChange)="toggleAllBannerPositions($event)" id="bannerBannerPositions" label="{{ 'SELECTALL' | translate }}"></p-checkbox>
                </div><!--/checkbox-->
              </div><!--/p-col-12-->
            </div><!--/p-fluid p-grid-->
            <div class="p-fluid p-grid">
              <div class="p-col-4">
                <button (click)="list()" class="btn btn-primary pull-left">
                  <i class="icon-layout-list-thumb"></i>
                  <span class="p-ml-1">{{ 'BACKBANNERS' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4 text-center">
                <button *ngIf="banner.id !== null" type="button" (click)="submitForm(false)" class="btn btn-primary" [disabled]="!bannerForm.valid || disableSubmit"> <!--  [disabled]="bannerForm.$invalid" -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && !redirect"></i>
                  <i class="fas fa-check-circle" *ngIf="!(disableSubmit && !redirect)"></i>
                  <span class="p-ml-1"> {{ 'APPLY' | translate }}</span>
                </button>
              </div>
              <div class="p-col-4">
                <button type="button" (click)="submitForm(true)" class="btn btn-primary pull-right" [disabled]="disableSubmit"> <!--  [disabled]="!bannerForm.valid || " -->
                  <i class="fas fa-spinner fa-spin" *ngIf="disableSubmit && redirect"></i>
                  <i class="icon-save" *ngIf="!(disableSubmit && redirect)"></i>
                  <span class="p-ml-1">{{ 'SAVE' | translate }}</span>
                </button>
              </div>
            </div>
          </form>
        </p-fieldset>
        <div class="p-fluid p-grid">
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
          <div class="col-sm-12 p-col-4 mb-2 text-center">
          </div>
          <div class="col-sm-12 p-col-4 mb-2">
          </div>
        </div>
      </div>
    </div><!--/p-col-12-->
  </div><!--/p-fluid p-grid-->
  <p-scrollTop target="parent"></p-scrollTop>
</div><!--/container-fluid container-fullw-->
<!-- end: FORM -->

